import { useEffect } from 'react'

import styles from './styles/PharmaPanel.css'
import TalkToUs from './TalkToUs'
import PartnerValueProp from './PartnerValueProp'
import PartnersPanel from './PartnersPanel'
import AwardsAndPress from './Awards'
import P from 'components/typography/Paragraph'
import * as analytics from 'lib/analytics'
import Button from '../forms/Button'
import classNames from 'classnames'

const PharmaPanel = () => {
  useEffect(() => {
    analytics.event({
      category: 'Partners',
      action: 'View Research and Development Partners Page'
    })
  }, [])

  return (
    <div className={styles.layout}>
      <TalkToUs
        header={false}
        cta={
          <Button className={classNames(styles.submitBtn, styles.transparentBtn)} onClick={() => window.open(`${CONFIG.assetsBaseURL}/documents/scite-case-study-pharmaceutical.pdf`)} color='transparent'>View case study</Button>
        }
        subheader='Get in touch with our team to learn more about how scite can help you better discover and understand research. View our case study to see how we have saved a pharmaceutical countless hours.'
        pricingTab='organizations'
      />
      <PartnerValueProp
        className={styles.valueProp}
        id='search-citations'
        header='Discover exactly how drugs, protocols, reagents, and more are being used'
        cta='Search Citation Statements'
        ctaLocation='/search/citations'
      >
        <P>
          Never waste time searching for research products in the literature again. Search over {CONFIG.defaultCitationsTotalText} citation statements for the most recent mentions of a drug, protocol, reagent, or other research product.
        </P>
        <img alt='citation-statement-search' src={`${CONFIG.assetsBaseURL}/images/citation-statement-search.png`} />
      </PartnerValueProp>
      <PartnerValueProp
        className={styles.valueProp}
        id='improve-effeciency'
        illo={`${CONFIG.assetsBaseURL}/images/icons/institution-spyglass.svg`}
        header='Find out how your research was cited by other scientific publications'
        cta='View your publications'
        ctaLocation='/affiliations'
      >
        <P>
          Keep track of emerging citations to your research and reseach assets with scite dashboards and alerts. Get updated when a study gets supported, contrasted, or receives a new editorial notice such as retracted or withdrawn.
        </P>
        <img alt='custom-dashboard' src={`${CONFIG.assetsBaseURL}/images/illustrations/sanofi-dashboard.png`} />
      </PartnerValueProp>
      <PartnerValueProp
        className={styles.valueProp}
        id='improve-effeciency'
        illo={`${CONFIG.assetsBaseURL}/images/icons/people-talking.svg`}
        header='Identify Experts and Key Opinion Leaders'
        cta='Search for experts'
        ctaLocation='/search'
      >
        <P>
          Find key researchers in any field and understand how their work has been supported, disputed, or mentioned by other researchers.
        </P>
        <img alt='key-opinion-leader' src={`${CONFIG.assetsBaseURL}/images/illustrations/key-opinion-leader.png`} />
      </PartnerValueProp>
      <PartnersPanel
        header='Who we’re working with'
        subheader="We've partnered with leading pharmaceuticals to help researchers discover and evaluate literature more effectively."
      />
      <AwardsAndPress />
      <TalkToUs
        pricingTab='organizations'
      />
    </div>
  )
}

export default PharmaPanel
